import { createAction, props } from '@ngrx/store'
import { Update } from '@ngrx/entity'
import {
  InvoiceRule,
  InvoiceRuleConditionCreate,
  InvoiceRuleConditionCreateComplete,
  InvoiceRuleConditionDeleteRequest,
  InvoiceRuleConditionSave,
  InvoiceRuleConditionSaveComplete,
  InvoiceRuleCreateForm,
  InvoiceRuleUpdateForm,
} from '@tokeet-frontend/invoices'

export const LoadInvoiceRules = createAction('[InvoiceRules] Load Rules')
export const LoadInvoiceRulesComplete = createAction(
  '[InvoiceRules] Load Rules Complete',
  props<{ rules: InvoiceRule[] }>()
)

export const ArchiveInvoiceRule = createAction('[InvoiceRules] Archive', props<{ rule: InvoiceRule }>())
export const ArchiveInvoiceRuleComplete = createAction(
  '[InvoiceRules] Archive Complete',
  props<{ update: Update<InvoiceRule> }>()
)

export const UnArchiveInvoiceRule = createAction('[InvoiceRules] UnArchive', props<{ rule: InvoiceRule }>())
export const UnArchiveInvoiceRuleComplete = createAction(
  '[InvoiceRules] UnArchive Complete',
  props<{ update: Update<InvoiceRule> }>()
)

export const DeleteInvoiceRule = createAction('[InvoiceRules] Delete Rule', props<{ id: string }>())
export const DeleteInvoiceRuleComplete = createAction('[InvoiceRules] Delete Rule Complete', props<{ id: string }>())

export const DuplicateInvoiceRule = createAction(
  '[InvoiceRules] Duplicate Rule',
  props<{ rule: InvoiceRule; name: string }>()
)

export const AddInvoiceRule = createAction(
  '[InvoiceRules] Add Rule',
  props<{ payload: InvoiceRuleCreateForm; silent: boolean }>()
)
export const AddInvoiceRuleComplete = createAction(
  '[InvoiceRules] Add Rule Complete',
  props<{ rule: InvoiceRule; silent?: boolean }>()
)
export const AddInvoiceRulesComplete = createAction(
  '[InvoiceRules] Add Rules Complete',
  props<{ rules: InvoiceRule[]; silent?: boolean }>()
)

export const UpdateInvoiceRule = createAction(
  '[InvoiceRules] Update Rule',
  props<{ payload: InvoiceRuleUpdateForm; pkey: string; silent: boolean }>()
)
export const UpdateInvoiceRuleComplete = createAction(
  '[InvoiceRules] Update Rule Complete',
  props<{ update: Update<InvoiceRule>; silent?: boolean }>()
)

export const DeleteInvoiceRules = createAction('[InvoiceRules] Delete Rules', props<{ ids: string[] }>())
export const DeleteInvoiceRulesComplete = createAction(
  '[InvoiceRules] Delete Rules Complete',
  props<{ ids: string[] }>()
)

export const PauseInvoiceRule = createAction('[InvoiceRule] Pause', props<{ id: string }>())
export const PauseInvoiceRuleComplete = createAction(
  '[InvoiceRule] Pause Complete',
  props<{ update: Update<InvoiceRule> }>()
)

export const ResumeInvoiceRule = createAction('[InvoiceRule] Resume', props<{ id: string }>())
export const ResumeInvoiceRuleComplete = createAction(
  '[InvoiceRule] Resume Complete',
  props<{ update: Update<InvoiceRule> }>()
)

export const PauseInvoiceRuleReminder = createAction('[InvoiceRule] Pause Reminder', props<{ id: string }>())
export const PauseInvoiceRuleReminderComplete = createAction(
  '[InvoiceRule] Pause Reminder Complete',
  props<{ update: Update<InvoiceRule> }>()
)

export const ResumeInvoiceRuleReminder = createAction(
  '[InvoiceRule] Resume Reminder',
  props<{ id: string; when: 'time.before.invoice.due' | 'time.after.invoice.due'; days: number }>()
)
export const ResumeInvoiceRuleReminderComplete = createAction(
  '[InvoiceRule] Resume Reminder Complete',
  props<{ update: Update<InvoiceRule> }>()
)

export const UpdateInvoiceRuleCondition = createAction(
  '[InvoiceRule] Update Condition Start',
  props<{ request: InvoiceRuleConditionSave }>()
)
export const UpdateInvoiceRuleConditionComplete = createAction(
  '[InvoiceRule] Update Condition Complete',
  props<{ response: InvoiceRuleConditionSaveComplete }>()
)

export const AddInvoiceRuleCondition = createAction(
  '[InvoiceRule] Add Condition Start',
  props<{ request: InvoiceRuleConditionCreate }>()
)
export const AddInvoiceRuleConditionComplete = createAction(
  '[InvoiceRule] Add Condition Complete',
  props<{ response: InvoiceRuleConditionCreateComplete }>()
)

export const DeleteInvoiceRuleCondition = createAction(
  '[InvoiceRule] Delete Condition Start',
  props<{ request: InvoiceRuleConditionDeleteRequest }>()
)
export const DeleteInvoiceRuleConditionComplete = createAction(
  '[InvoiceRule] Delete Condition Complete',
  props<{ response: InvoiceRuleConditionDeleteRequest }>()
)
